import React from 'react'

export const Loading = () => <div>Loading...</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/loading.tsx